module.exports = __webpack_public_path__ + "img/dash-card-commission.cb4e56cb.svg";